import axios from 'axios';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;


export const fetchLeaderBoard = (user, startDate, endDate) => {
    return (dispatch) => {
        dispatch({ type: 'FETCH_LEADERBOARD_LIST' });
        axios.get(baseURL + 'leaderboard', {
            params: {
                token: user.token,
                user_id: user.user_id,
                start_week: startDate,
                end_week: endDate
            }
        }).then(response => {
            console.log(response);
            dispatch({ type: 'FETCH_LEADERBOARD_LIST_SUCCESS', payload: response.data.data });
        }).catch(err => {
            dispatch({ type: 'FETCH_LEADERBOARD_LIST_FAIL' });
            console.log(err);
        });
    };
};

export const fetchImages = (user, startDate, endDate) => {
    return (dispatch) => {
        dispatch({ type: 'FETCH_IMAGES' });
        axios.get(baseURL + 'campaign/activity', {
            params: {
                user_id: user.user_id,
                token: user.token,
                user_type: 'admin',
                start_week: startDate,
                end_week: endDate
            }
        }).then(response => {
            console.log(response);
            dispatch({ type: 'FETCH_IMAGES_SUCCESS', payload: response.data.data });
        }).catch(err => {
            dispatch({ type: 'FETCH_IMAGES_FAIL' });
            console.log(err);
        });
    };
};

export const imageSelection = (image) => {
    return {
        type: 'IMAGE_SELECTION',
        payload: image
    };
};




// WEBPACK FOOTER //
// ./src/actions/LeaderBoard/LeaderBoardAction.js